import * as CookieConsent from "vanilla-cookieconsent";

/**
 * All config. options available here:
 * https://cookieconsent.orestbida.com/reference/configuration-reference.html
 */
CookieConsent.run({
    disablePageInteraction: true,
    // root: 'body',
    // autoShow: true,
    // disablePageInteraction: true,
    // hideFromBots: true,
    // mode: 'opt-in',
    // revision: 0,

    // cookie: {
    //     name: 'cc_cookie',
        // domain: location.hostname,
        // path: '/',
        // sameSite: "Lax",
        // expiresAfterDays: 365,
    // },

    // https://cookieconsent.orestbida.com/reference/configuration-reference.html#guioptions
    guiOptions: {
        consentModal: {
            layout: 'box wide',
            position: 'bottom center',
            equalWeightButtons: false,
            flipButtons: false,
            transition: 'slide'
        },
        preferencesModal: {
            layout: 'box',
            equalWeightButtons: false,
            flipButtons: false,
            transition: 'slide'
        }
    },

    onFirstConsent: ({cookie}) => {
        registerCookiePreference(cookie)
        // location.reload();
    },

    onConsent: ({cookie}) => {
        updateGtagConsent();
        // commentato in quanto il pixel di facebook e il consent è gestito tramite GTM
        // updateFBConsent();
    },

    onChange: ({changedCategories, changedServices}) => {

        registerCookiePreference(changedCategories)
        updateGtagConsent();
        // location.reload();
        // commentato in quanto il pixel di facebook e il consent è gestito tramite GTM
        // updateFBConsent();
    },

    // onModalReady: ({modalName}) => {
    //     console.log('ready:', modalName);
    // },
    //
    // onModalShow: ({modalName}) => {
    //     console.log('visible:', modalName);
    // },
    //
    // onModalHide: ({modalName}) => {
    //     console.log('hidden:', modalName);
    // },

    categories: {
        necessary: {
            enabled: true,  // this category is enabled by default
            readOnly: true  // this category cannot be disabled
        },
        analytics: {
            autoClear: {
                cookies: [
                    {
                        name: /^_ga/,   // regex: match all cookies starting with '_ga'
                    },
                    {
                        name: '_gid',   // string: exact cookie name
                    }
                ]
            },

            // https://cookieconsent.orestbida.com/reference/configuration-reference.html#category-services
            // services: {
                // ga: {
                //     label: 'Google Analytics',
                //     onAccept: () => {},
                //     onReject: () => {}
                // },
                // youtube: {
                //     label: 'Youtube Embed',
                //     onAccept: () => {},
                //     onReject: () => {}
                // },
            // }
        },
        targeting: {},
        functionality: {}
    },

    language: {
        default: 'it',
        autoDetect: 'document',
        translations: {
            it: {
                consentModal: {
                    title: ' I Cookie rendono le cose migliori!',
                    description: 'Utilizziamo cookie e identificatori di prima o terza parte con il tuo consenso e/o nostro interesse legittimo, allo scopo di immagazzinare o accedere alle informazioni sul tuo dispositivo, per raccogliere dati personali degli utenti per sviluppare e migliorare prodotti, nonché per visualizzare e misurare pubblicità  nostra e/o di terzi e/o contenuti personalizzati basati sulla tua navigazione (ad esempio le pagine visitate).', //
                    acceptAllBtn: 'Accetto tutti i Cookie',
                    acceptNecessaryBtn: 'Rifiuta tutti',
                    showPreferencesBtn: 'Impostazioni',
                    equalWeightButtons: false
                    // closeIconLabel: 'Reject all and close modal',
                },
                preferencesModal: {
                    title: 'Centro preferenze sulla privacy',
                    acceptAllBtn: 'Accetta tutti',
                    acceptNecessaryBtn: 'Rifiuta tutti',
                    savePreferencesBtn: 'Salva le impostazioni',
                    closeIconLabel: 'Chiudi',
                    serviceCounterLabel: 'Servizio|Servizi',
                    equalWeightButtons: false,
                    sections: [
                        {
                            title: 'Opzioni Cookie',
                            description: 'Questo sito Web utilizza cookie essenziali per garantirne il corretto funzionamento e cookie di tracciamento per capire come interagisci con esso. Quest\'ultimo sarà impostato solo previo consenso.'
                        },
                        {
                            title: 'Cookie strettamente necessari',
                            description: 'Questi cookie sono necessari per il funzionamento del sito e non possono essere disattivati nei nostri sistemi. Di solito vengono impostati solo in risposta alle azioni da te effettuate che costituiscono una richiesta di servizi, come l\'impostazione delle preferenze di privacy, l\'accesso o la compilazione di moduli. È possibile impostare il browser per bloccare o avere avvisi riguardo questi cookie, ma di conseguenza alcune parti del sito non funzioneranno. Questi cookie non archiviano informazioni personali.',
                            linkedCategory: 'necessary',
                            cookieTable: {
                                headers: {
                                    name: 'Cookie',
                                    domain: 'Dominio',
                                    desc: 'Descrizione',
                                },
                                body: [
                                    {
                                        name: 'october_session',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Conserva lo stato della sessione del visitatore tra le richieste di pagina.',
                                    },
                                    {
                                        name: 'cc_cookie',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Memorizza lo stato del consenso ai cookie dell\'utente per il dominio corrente.',
                                    },
                                ]
                            }
                        },
                        {
                            title: 'Cookie di analisi e prestazione',
                            description: 'Questi cookie ci permettono di contare le visite e fonti di traffico in modo da poter misurare e migliorare le prestazioni del nostro sito. Ci aiutano a sapere quali sono le pagine più e meno popolari e vedere come i visitatori si muovono intorno al sito. Tutte le informazioni raccolte dai cookie sono aggregate e quindi anonime. Se non consenti questi cookie, non sapremo quando hai visitato il nostro sito.',
                            linkedCategory: 'analytics',
                            cookieTable: {
                                headers: {
                                    name: 'Cookie',
                                    domain: 'Dominio',
                                    desc: 'Descrizione'
                                },
                                body: [
                                    {
                                        name: '_ga',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Registra un ID univoco utilizzato per generare dati statistici su come il visitatore utilizza il sito internet',
                                    },
                                    {
                                        name: '_gid',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Registra un ID univoco utilizzato per generare dati statistici su come il visitatore utilizza il sito internet',
                                    },
                                    {
                                        name: '_gat',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Utilizzato da Google Analytics per limitare la frequenza delle richieste',
                                    }
                                ]
                            }
                        },
                        {
                            title: 'Cookie per pubblicità mirata',
                            description: 'Questi cookie possono essere impostati tramite il nostro sito dai nostri partner pubblicitari. Possono essere utilizzati da queste aziende per costruire un profilo dei tuoi interessi e mostrarti annunci pertinenti su altri siti. Non memorizzano direttamente informazioni personali, ma sono basati unicamente sull/individuazione del tuo browser e del tuo dispositivo internet. Se non si accettano questi cookie, riceverai una pubblicità meno mirata.',
                            linkedCategory: 'targeting',
                            cookieTable: {
                                headers: {
                                    name: 'Cookie',
                                    domain: 'Domain',
                                    desc: 'Descrizione'
                                },
                                body: [
                                    {
                                        name: '_fbp',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Utilizzato per tracciare i visitatori su più siti Web, al fine di visualizzare annunci pubblicitari recenti pertinenti in base alle preferenze del visitatore.  ',
                                    },
                                    {
                                        name: 'mtc_id',
                                        domain: window.location.hostname,
                                        desc: "HTTP - Utilizzato per tracciare i visitatori su più siti Web, al fine di visualizzare annunci pubblicitari recenti pertinenti in base alle preferenze del visitatore.  ",
                                    },
                                    {
                                        name: 'mautic_device_id',
                                        domain: window.location.hostname,
                                        desc: "HTTP - Utilizzato per identificare il visitatore attraverso le visite e i dispositivi. Ciò consente al sito web di presentare il visitatore con Pubblicità pertinente - Il servizio è fornito da centri pubblicitari di terze parti, che facilitano le offerte in tempo reale per gli inserzionisti. ",
                                    },
                                    {
                                        name: 'mautic_referer_id',
                                        domain: window.location.hostname,
                                        desc: "HTTP - Raccoglie informazioni sul comportamento degli utenti su più siti web. Queste informazioni vengono utilizzate per ottimizzare la pertinenza della pubblicità sul sito web.  ",
                                    },
                                    {
                                        name: 'mtc_sid',
                                        domain: window.location.hostname,
                                        desc: "HTTP - Utilizzato per tracciare i visitatori su più siti Web, al fine di visualizzare annunci pubblicitari recenti pertinenti in base alle preferenze del visitatore.  ",
                                    }
                                ]
                            }
                        },
                        {
                            title: 'Cookie di funzionalità',
                            description: 'Questi cookie consentono ai siti web di ricordare le preferenze dell\'utente e le scelte effettuate sul sito, compresi i dati di accesso, la geo-localizzazione, la lingua e i contenuti avanzati.',
                            linkedCategory:'functionality',
                            cookieTable: {
                                    headers: {
                                        name: 'Cookie',
                                        domain: 'Domain',
                                        desc: 'Descrizione'
                                    },
                                    body: []
                            }
                        },
                        {
                            title: 'Maggiori informazioni',
                            description: 'Per maggiori informazioni consulta la nostra <a href="/it/privacy-cookie" class="cc-link">privacy policy e la cookie policy</a>.',
                        }
                    ]
                }
            },
            en: {
                consentModal: {
                    title: 'Cookies make things better! ',
                    description: 'We use cookies and first or third party identifiers with your consent and / or our legitimate interest, for the purpose of storing or accessing information on your device, to collect personal user data to develop and improve products, as well as to display and measure advertising. ours and / or third parties and / or personalized content based on your navigation (for example the pages you visit).',
                    acceptAllBtn: 'Accept all Cookies',
                    acceptNecessaryBtn: 'Reject all',
                    showPreferencesBtn: 'Settings',
                    equalWeightButtons: false
                    // closeIconLabel: 'Reject all and close modal',
                },
                preferencesModal: {
                    title: 'Privacy Preference Centre',
                    acceptAllBtn: 'Accept all',
                    acceptNecessaryBtn: 'Reject all',
                    savePreferencesBtn: 'Save settings',
                    closeIconLabel: 'Close',
                    serviceCounterLabel: 'Service|Services',
                    equalWeightButtons: false,
                    sections: [
                        {
                            title: 'Cookie Options',
                            description: 'This website uses essential cookies to ensure it works properly and tracking cookies to understand how you interact with it. The latter will only be set with your consent.'
                        },
                        {
                            title: 'Strictly necessary cookies',
                            description: 'These cookies are necessary for the operation of the site and cannot be disabled in our systems. They are usually set only in response to actions you take that constitute a request for services, such as setting privacy preferences, logging in, or filling out forms. You can set your browser to block or have warnings about these cookies, but as a result some parts of the site will not work. These cookies do not store personal information.',
                            linkedCategory: 'necessary',
                            cookieTable: {
                                headers: {
                                    name: 'Cookie',
                                    domain: 'Domain',
                                    desc: 'Description',
                                },
                                body: [
                                    {
                                        name: 'october_session',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Preserves the visitor\'s session state between page requests.'
                                    },
                                    {
                                        name: 'cc_cookie',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Stores the user\'s cookie consent status for the current domain.',
                                    },
                                ]
                            }
                        },
                        {
                            title: 'Analytics and performance cookies',
                            description: 'These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. They help us know which pages are the most and least popular and see how visitors move around the site. All information collected by cookies is aggregated and therefore anonymous. If you do not allow these cookies, we will not know when you visited our site.',
                            linkedCategory: 'analytics',
                            cookieTable: {
                                headers: {
                                    name: 'Cookie',
                                    domain: 'Domain',
                                    desc: 'Description',
                                },
                                body: [
                                    {
                                        name: '_ga',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Records a unique ID used to generate statistical data on how the visitor uses the website',
                                    },
                                    {
                                        name: '_gid',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Records a unique ID used to generate statistical data on how the visitor uses the website',
                                    },
                                    {
                                        name: '_gat',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Used by Google Analytics to limit the frequency of requests',
                                    }
                                ]
                            }
                        },
                        {
                            title: 'Cookies for targeted advertising',
                            description: 'These cookies may be set through our site by our advertising partners. They can be used by these companies to build a profile of your interests and show you relevant ads on other sites. They do not directly store any personal information, but are based solely on/on the tracking of your Internet browser and device. If you do not accept these cookies, you will receive less targeted advertising.',                            linkedCategory: 'targeting',
                            cookieTable: {
                                headers: {
                                    name: 'Cookie',
                                    domain: 'Domain',
                                    desc: 'Description',
                                },
                                body: [
                                    {
                                        name: '_fbp',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Used to track visitors on multiple Web sites in order to display relevant recent advertisements based on the visitor\'s preferences.  ',
                                    },
                                    {
                                        name: 'mtc_id',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Used to track visitors on multiple Web sites in order to display relevant recent advertisements based on the visitor\'s preferences.  ',
                                    },
                                    {
                                        name: 'mautic_device_id',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Used to identify the visitor across visits and devices. This allows the website to present the visitor with Relevant Advertising - The service is provided by third-party advertising centers, which facilitate real-time bidding for advertisers.',
                                    },
                                    {
                                        name: 'mautic_referer_id',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Collects information about user behavior on multiple websites. This information is used to optimize the relevance of advertising on the website.',
                                    },
                                    {
                                        name: 'mtc_sid',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Used to track visitors on multiple Web sites in order to display relevant recent advertisements based on the visitor\'s preferences.',
                                    }
                                ]
                            }
                        },
                        {
                            title: 'Cookies for functionality',
                            description: 'These cookies allow websites to remember the user’s website preferences and choices they make on the website including login details, geo-location, language, and enhanced content.',
                            linkedCategory:'functionality',
                            cookieTable: {}
                        },
                        {
                            title: 'More information',
                            description: 'For more information see our <a href="/en/privacy-cookie" class="cc-link">privacy policy and cookie policy</a>.',
                        }
                    ]
                }
            },
            fr: {
                consentModal: {
                    title: 'Les cookies rendent les choses meilleures!',
                    description: 'Nous utilisons des cookies et des identifiants propriétaires ou tiers avec votre consentement et / ou notre intérêt légitime, dans le but de stocker ou d\'accéder à des informations sur votre appareil, de collecter des données personnelles de l\'utilisateur pour développer et améliorer les produits, ainsi que pour afficher et mesurer la publicité . les nôtres et/ou des tiers et/ou des contenus personnalisés en fonction de votre navigation (par exemple les pages que vous visitez).',
                    acceptAllBtn: 'Accepter tous',
                    acceptNecessaryBtn: 'Tout rejeter',
                    showPreferencesBtn: 'Paramètres',
                    equalWeightButtons: false
                    // closeIconLabel: 'Reject all and close modal',
                },
                preferencesModal: {
                    title: 'Centre de préférences en matière de confidentialité',
                    acceptAllBtn: 'Accepter tous',
                    acceptNecessaryBtn: 'Tout rejeter',
                    savePreferencesBtn: 'Enregistrer les paramètres',
                    closeIconLabel: 'fermer',
                    serviceCounterLabel: 'Service|Prestations',
                    equalWeightButtons: false,
                    sections: [
                        {
                            title: 'Options des cookies',
                            description: 'Ce site Web utilise des cookies essentiels pour garantir son bon fonctionnement et des cookies de suivi pour comprendre comment vous interagissez avec lui. Cette dernière ne sera fixée qu\'avec votre accord.'
                        },
                        {
                            title: 'Cookies strictement nécessaires',
                            description: 'Ces cookies sont nécessaires au fonctionnement du site et ne peuvent pas être désactivés dans nos systèmes. Ils sont généralement définis uniquement en réponse aux actions que vous entreprenez et qui constituent une demande de services, telles que la définition de préférences de confidentialité, la connexion ou le remplissage de formulaires. Vous pouvez configurer votre navigateur pour bloquer ou recevoir des avertissements concernant ces cookies, mais par conséquent certaines parties du site ne fonctionneront pas. Ces cookies ne stockent pas d\'informations personnelles.',
                            linkedCategory: 'necessary',
                            cookieTable: {
                                headers: {
                                    name: 'Cookie',
                                    domain: 'Domain',
                                    desc: 'Description',
                                },
                                body: [
                                    {
                                        name: 'october_session',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Préserve l\'état de session du visiteur entre les requêtes de page.'
                                    },
                                    {
                                        name: 'cc_cookie',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Stocke le statut de consentement aux cookies de l\'utilisateur pour le domaine actuel.',
                                    },
                                ]
                            }
                        },
                        {
                            title: 'Cookies d\'analyse et de performance',
                            description: 'Ces cookies nous permettent de compter les visites et les sources de trafic afin de pouvoir mesurer et améliorer les performances de notre site. Ils nous aident à savoir quelles pages sont les plus et les moins populaires et à voir comment les visiteurs se déplacent sur le site. Toutes les informations collectées par les cookies sont agrégées et donc anonymes. Si vous n\'autorisez pas ces cookies, nous ne saurons pas quand vous avez visité notre site.',
                            linkedCategory: 'analytics',
                            cookieTable: {
                                headers: {
                                    name: 'Cookie',
                                    domain: 'Domain',
                                    desc: 'Description',
                                },
                                body: [
                                    {
                                        name: '_ga',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Enregistre un identifiant unique utilisé pour générer des données statistiques sur la façon dont le visiteur utilise le site Web',
                                    },
                                    {
                                        name: '_gid',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Enregistre un identifiant unique utilisé pour générer des données statistiques sur la façon dont le visiteur utilise le site Web',
                                    },
                                    {
                                        name: '_gat',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Utilisé par Google Analytics pour limiter la fréquence des requêtes',
                                    }
                                ]
                            }
                        },
                        {
                            title: 'Cookies pour la publicité ciblée',
                            description: 'Ces cookies peuvent être installés sur notre site par nos partenaires publicitaires. Ils peuvent être utilisés par ces sociétés pour établir un profil de vos intérêts et vous montrer des publicités pertinentes sur d\'autres sites. Ilsne stockent pas directement d\'informations personnelles, mais se basent uniquement sur le suivi de votre navigateur Internet et de votre appareil. Si vous n\'acceptez pas ces cookies, vous recevrez des publicités moins ciblées.',
                            linkedCategory: 'targeting',
                            cookieTable: {
                                headers: {
                                    name: 'Cookie',
                                    domain: 'Domain',
                                    desc: 'Description',
                                },
                                body: [
                                    {
                                        name: '_fbp',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Utilisé pour suivre les visiteurs sur plusieurs sites Web afin d\'afficher des publicités récentes pertinentes en fonction des préférences du visiteur.',
                                    },
                                    {
                                        name: 'mtc_id',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Used to track visitors on multiple Web sites in order to display relevant recent advertisements based on the visitor\'s preferences.  ',
                                    },
                                    {
                                        name : 'mautic_device_id',
                                        domain : window.location.hostname,
                                        desc : 'HTTP - Utilisé pour identifier le visiteur à travers les visites et les appareils. Cela permet au site web de présenter au visiteur une publicité pertinente - Le service est fourni par des centres publicitaires tiers, qui facilitent les enchères en temps réel pour les annonceurs.',
                                    },
                                    {
                                        name : 'mautic_referer_id',
                                        domain : window.location.hostname,
                                        desc : 'HTTP - Recueille des informations sur le comportement de \'utilisateur sur plusieurs sites web. Ces informations sont utilisées pour optimiser la pertinence de la publicité sur le site web.',
                                    },
                                    {
                                        name : 'mautic_referer_id',
                                        domain : window.location.hostname,
                                        desc : 'HTTP - Collecte des informations sur le comportement des utilisateurs sur plusieurs sites web. Ces informations sont utilisées pour optimiser la pertinence de la publicité sur le site web.',
                                    },
                                    {
                                        name : 'mtc_sid',
                                        domain : window.location.hostname,
                                        desc : 'HTTP - Utilisé pour suivre les visiteurs sur plusieurs sites web afin d\'afficher des publicités récentes et pertinentes en fonction des préférences du visiteur.',
                                    }
                                ]
                            }
                        },
                        {
                            title: 'Cookies de fonctionnalité',
                            description: 'Ces cookies permettent aux sites Web de mémoriser les préférences de l’utilisateur et les choix qu’il fait sur le site Web, notamment les informations de connexion, la géolocalisation, la langue et le contenu amélioré.',
                            linkedCategory: 'fonctionnalité',
                            cookieTable: {}
                        },
                        {
                            title: 'Pour plus d\'informations',
                            description: 'Pour toute question relative à notre politique en matière de cookies et à vos choix, veuillez vous adresser à <a class="cc-link" href="/fr/privacy-policy">Privacy policy</a>.',
                        }
                    ]
                }
            }
        }
    }
});

const updateGtagConsent = () => {
    const consentMode = {
        'ad_storage': CookieConsent.acceptedCategory('targeting') ? 'granted' : 'denied',
        'ad_user_data': CookieConsent.acceptedCategory('targeting') ? 'granted' : 'denied',
        'ad_personalization': CookieConsent.acceptedCategory('targeting') ? 'granted' : 'denied',
        'analytics_storage': CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied',
        'functionality_storage': CookieConsent.acceptedCategory('functionality') ? 'granted' : 'denied',
        'personalization_storage': CookieConsent.acceptedCategory('preference') ? 'granted' : 'denied',
        'security_storage': 'granted', //necessary
        // 'region': ['IT', 'ES','AL','AT','BE','BG']
        // 'wait_for_update': 500
    };

    gtag('consent', 'update', consentMode);
};

const updateFBConsent = () => {
    fbq('consent', CookieConsent.acceptedCategory('targeting') ? 'grant' : 'revoke');
};

function registerCookiePreference() {
    let cookiEntries = {
        'targeting': CookieConsent.acceptedCategory('targeting') ? '1' : '0',
        'analytics': CookieConsent.acceptedCategory('analytics') ? '1' : '0',
        'functionality': CookieConsent.acceptedCategory('functionality') ? '1' : '0',

    }

    $.request('onLogEntries',{
        data: {cookiEntries: cookiEntries},
    })
}

